export { LeadsRegistryChatScopeFilter } from './ui/LeadsRegistryChatScopeFilter';
export type { LeadsRegistryChatScope } from '../../../model/types';
